import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
// import { DropDownList } from "@progress/kendo-react-dropdowns";
import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import InnerLoader from "../../Shared/Loader/InnerLoader";
import { getNode } from "../../Helpers/Nodes";
import Upgarde from "../../Shared/Subscription/Upgrade";
import { cloneProject } from "../../../API/Project/project";
import ShuffleMessage from "../../Shared/ShuffleMessage/ShuffleMessage";
import { bindShuffleMessageI18nEvents, messages } from "../../Shared/ShuffleMessage/MessagesHelper";

class UseSolutionTemplate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedOrganization: {},
            redirect: false,
            CreatingProject: false,
            CreatingProjectName: "",
            showUpgradeDailog: false,
            error: {
                isValid: true,
                message: "",
            }
        }
    }

    componentDidMount = async () => {
        bindShuffleMessageI18nEvents();
        this.setState({
            selectedOrganization: this.props.organization
        });
    };

    render() {
        if (this.state.redirect) {
            return (
                <Navigate
                    to={
                        "/" +
                        this.state.selectedOrganization.number +
                        "/" +
                        this.state.CreatingProjectName
                    }
                    state={{
                        applicationCloned: true
                    }}
                />
            );
        }

        if (this.state.showUpgradeDailog) {
            return (
                <Upgarde
                    organization={this.state.selectedOrganization}
                    Headline={'Need to build <br/>more apps? '}
                    toggleDialog={this.toggleUpgradeDailog}
                    Type={'Pro'}
                />
            )
        }

        if (this.state.CreatingProject) {
            return (
                <Dialog
                    width={"45%"}
                    height={"50%"}>
                    <div className="d-flex flex-column justify-content-enter align-items-center w-100 h-100">
                        <div style={{ height: "80%" }}>
                            <img
                                alt="loader-clone"
                                height={"100%"}
                                src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/loaders/library.gif`} />
                        </div>
                        <ShuffleMessage
                            data={messages["cloneApp"] || []}
                            interval={4000}
                        />
                    </div>
                </Dialog>
            )
        }

        return (
            <Dialog
                width={"45%"}
                title="Use App"
                onClose={this.props.onClose}
            >
                <form className="mx-2" onSubmit={this.cloneProject}>
                    {!this.state.error.isValid && (
                        <div className="col-12">
                            <div className="alert alert-danger">
                                {this.state.error.message}
                            </div>
                        </div>
                    )}
                    <div className="form-label d-block">Selected app</div>
                    <div className="d-flex reg">
                        {
                            this.props.solution.TilesImageName !== undefined &&
                            <img
                                alt="Application"
                                style={{ width: 120, borderRadius: 10 }}
                                src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_CONTAINER}/${this.props.solution.organizationId}/${this.props.solution._id}/ProjectImages/${this.props.solution.TilesImageName}`}
                            />
                        }
                        <div className={this.props.solution.TilesImageName !== undefined ? "d-flex p-3 flex-column" : "d-flex py-3 flex-column"}>
                            <div>
                                <span className="big me-2">
                                    {this.props.solution.name}
                                </span>
                                {this.props.solution.isSuperApp === true && (
                                    <span className="px-2 py-1 super-app">
                                        <i className="mx-1 fas fa-rocket"></i>
                                        SUPER APP
                                    </span>
                                )}

                                {this.props.solution.isFeaturedApp ===
                                    "true" && (
                                        <span className="px-2 py-1 mx-1 featured-app">
                                            <i className="mx-1 fas fa-star"></i>
                                            FEATURED APP
                                        </span>
                                    )}
                            </div>

                            <div className="text-justify four-line-truncate text-2 my-4 ">
                                {this.props.solution.description}
                            </div>
                        </div>
                    </div>

                    <DialogActionsBar layout="end">
                        <small className="mt-1">
                            {this.state.CreatingProject && (
                                <div className="d-inline-block">
                                    <InnerLoader borderColor="green" />
                                    <span className="me-4 text-success"></span>
                                </div>
                            )}
                        </small>
                        <button
                            type="button"
                            onClick={this.props.onClose}
                            className="me-1 btn btn-secondary"
                        >
                            Cancel
                        </button>
                        <button
                            autoFocus={true}
                            onClick={this.cloneProject}
                            type={'submit'}
                            className="btn btn-primary"
                            disabled={this.state.CreatingProject || !this.state.selectedOrganization.id}                        >
                            Use App
                        </button>
                    </DialogActionsBar>
                </form>
            </Dialog>
        );
    }

    // handleOrganization = (e) => {
    //     this.setState({
    //         selectedOrganization: e.target.value,
    //     });
    // };

    toggleUpgradeDailog = () => {
        this.props.onClose()
    }

    cloneProject = async (e) => {
        e.preventDefault();
        this.setState({
            CreatingProject: true
        })
        let project = await getNode(this.props.solution.id, "Project");
        let response = await cloneProject(project, this.state.selectedOrganization, project.organizationId, false);
        if (response.status === "success") {
            this.setState({
                redirect: true,
                CreatingProjectName: response.data.name,
                CreatingProject: false,
            });
        } else {
            this.setState({
                CreatingProject: false,
                showUpgradeDailog: response.type === "upgrade" ? true : false,
                error: response.error
            })
        }
    };
}

export default UseSolutionTemplate;
